import React, { useState, useEffect } from 'react';
import { FiBellOff } from 'react-icons/fi';
import { Tabs } from '../app/components/Tabs';
import { usePageTitle } from '../contexts/PageTitleContext';


const Notification = () => {
  const { setTitle } = usePageTitle();

  useEffect(() => {
    setTitle('Notificações');
  }, [setTitle]);
  
  const [filtroAtivo, setFiltroAtivo] = useState('Não lidas');

  const handleFiltroChange = (filtro) => {
    setFiltroAtivo(filtro);
  };

  const tabsOptions = ['Não lidas', 'Lidas', 'Todas'];

  return (
    <div>
      <div className="bg-white min-h-screen">
        <div className="mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="mb-6">
            <h1 className="text-md font-medium text-gray-800">
              Gerencie suas notificações recentes
            </h1>
          </div>

          <div className="border-b pb-4 mb-10">
            <Tabs 
              tabsName={tabsOptions} 
              activeTabName={filtroAtivo} 
              onTabClick={handleFiltroChange}
              align="left"
            />
          </div>

          <div className="flex flex-col items-center justify-center py-12">
            <div className="mb-4">
              <FiBellOff className="h-8 w-8" />
            </div>
            <p className="text-gray-700 font-medium mb-1">Sem notificações</p>
            <p className="text-gray-500 text-sm">
              Não há notificações para exibir neste momento.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notification;